import axios from "axios";
import {
    LOCATION_LIST_REQUEST,
    LOCATION_LIST_SUCCESS,
    LOCATION_LIST_FAIL,
    LOCATION_DETAILS_REQUEST,
    LOCATION_DETAILS_SUCCESS,
    LOCATION_DETAILS_FAIL
} from "../constants/categoryConstants";
import { BASE_URL, LOCATION_URL } from "../api";


export const listLocation = () => async (dispatch) => {
  try {
    dispatch({ type: LOCATION_LIST_REQUEST });
    const { data } = await axios.get(BASE_URL+LOCATION_URL);
    dispatch({
      type: LOCATION_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOCATION_LIST_FAIL,
      
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};



export const listLocationDetails =(id) => async (dispatch)=>{

  try{
      dispatch({type:LOCATION_DETAILS_REQUEST})
      const {data} = await axios.get(`/api/products/${id}`)

      dispatch({
          type:LOCATION_DETAILS_SUCCESS,
          payload:data
      })

  }
  catch(error){
      dispatch({
          type:LOCATION_DETAILS_FAIL,
          payload:error.response && error.response.data.detail
          ? error.response.data.detail
          :error.message,
      })

  }
}